import { useState } from 'preact/hooks'
import { CanvasProtectionError } from '../icon/canvasProtection'
import { downloadSVG, downloadZip } from '../icon/export'
import type { IconConfig } from '../types'
import { inputValue } from '../utils/input'
import { Button, ButtonRow } from './Button'

interface Props {
  config: IconConfig
  onAppName: (name: string) => void
}

export function ExportPanel({ config, onAppName }: Props) {
  const [error, setError] = useState<string | null>(null)

  const handleZip = async () => {
    setError(null)

    try {
      await downloadZip(config)
    } catch (err) {
      if (err instanceof CanvasProtectionError) {
        setError(err.message)
      } else if (err instanceof Error) {
        setError(`PNG export failed: ${err.message}`)
      } else {
        setError('PNG export failed')
      }
    }
  }

  const handleSvg = async () => {
    setError(null)

    try {
      await downloadSVG(config)
    } catch (err) {
      if (err instanceof Error) {
        setError(`SVG export failed: ${err.message}`)
      } else {
        setError('SVG export failed')
      }
    }
  }

  return (
    <div class="export-stack">
      <div class="export-bar">
        <input
          type="text"
          value={config.appName}
          onInput={(event) => onAppName(inputValue(event))}
          placeholder="harbour-myapp"
        />
        <ButtonRow>
          <Button onClick={handleZip}>Download ZIP</Button>
          <Button variant="secondary" onClick={handleSvg}>
            SVG
          </Button>
        </ButtonRow>
      </div>
      {error && (
        <p class="export-error" role="alert">
          {error}
        </p>
      )}
      <p class="export-hint">
        ZIP drops into your project root — matches <code>SAILFISHAPP_ICONS</code>.
      </p>
    </div>
  )
}
